var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M482,245.2v-60.4c0-29.7-23.6-53.9-53-54.9V92.9c0-19.3-15.7-35-35-35h-96.4l-12.4-34.6c-3.2-8.8-9.6-15.9-18.1-19.8 c-8.5-4-18-4.4-26.8-1.2L65.4,65.9c-8.8,3.2-15.8,9.6-19.8,18.1s-4.3,18-1.1,26.8l7,19.2C22.8,131.8,0,155.7,0,184.9v272 c0,30.3,24.7,55,55,55h372c30.3,0,55-24.7,55-55v-62.4c16.9-2.4,30-17,30-34.6v-80C512,262.3,498.9,247.7,482,245.2z M482,359.9 c0,2.8-2.2,5-5,5h-80c-24.8,0-45-20.2-45-45s20.2-45,45-45h80c2.8,0,5,2.2,5,5V359.9z M72.7,100.5c-0.5-1.2-0.4-2.6,0.2-3.8 c0.6-1.2,1.6-2.1,2.8-2.6l174.9-63.6c1.7-0.6,3.1-0.2,3.8,0.2s2,1.1,2.6,2.8l8.8,24.4H259c-19.3,0-35,15.7-35,35v37H83.5 L72.7,100.5z M399,92.9v37H254v-37c0-2.8,2.2-5,5-5h135C396.8,87.9,399,90.1,399,92.9z M427,481.9H55c-13.8,0-25-11.2-25-25v-272 c0-13.8,11.2-25,25-25h372c13.8,0,25,11.2,25,25v60h-55c-41.4,0-75,33.6-75,75s33.6,75,75,75h55v62 C452,470.7,440.8,481.9,427,481.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397,
    cy: 319.9,
    r: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBlack);
export default __webpack_public_path__ + "static/media/wallet-black.8ac4f371f5f78b080b122468225f9f15.svg";
export { ForwardRef as ReactComponent };